import PropTypes from "prop-types";
import { Box, Paper, Typography } from "@mui/material";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

const ICON_MAP = {
  total: GroupsOutlinedIcon,
  month: CalendarMonthOutlinedIcon,
  year: PersonAddOutlinedIcon,
  check: CheckCircleOutlineOutlinedIcon,
};

const StatsCard = ({ value, label, icon = "total", bgColor = "#F5F6FA" }) => {
  const Icon = ICON_MAP[icon] || ICON_MAP.total;

  return (
    <Paper
      elevation={0}
      sx={{
        minHeight: 100,
        borderRadius: "8px",
        bgcolor: bgColor,
        px: 2,
        py: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        border: "1px solid #EFEFF4",
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 28,
            fontWeight: 800,
            lineHeight: 1,
            color: "#111827",
            mb: 0.8,
          }}
        >
          {value ?? "--"}
        </Typography>

        <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#687083" }}>
          {label}
        </Typography>
      </Box>

      <Box
        sx={{
          width: 52,
          height: 52,
          borderRadius: "8px",
          bgcolor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0px 18px 32px rgba(45, 49, 95, 0.10)",
          flexShrink: 0,
        }}
      >
        <Icon sx={{ fontSize: 30, color: "#111827" }} />
      </Box>
    </Paper>
  );
};

StatsCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  bgColor: PropTypes.string,
};

export default StatsCard;
